import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";
import ScrollAnimation from "react-animate-on-scroll";

export function Contact(){
  return(
    <Container id="contact">
       <header>
       <ScrollAnimation animateIn="fadeInUp">
        <h2>Contact Me</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2*1000}>
          <p>If you've seen my potential or want to talk to me, don't hesitate to send me a message.</p>
        </ScrollAnimation>
        </header>
      <div className="contacts">
        <div>
          <img src={emailIcon} alt="Email" />
          <a href="mailto:bustamanteflocerangelo@gmail.com">bustamanteflocerangelo@gmail.com</a>
        </div>
        <div>
          <img src={phoneIcon} alt="Email" />
          <a href="tel:09482440776">09482440776</a>
        </div>  
      </div>
      <Form></Form>
    </Container>
  )
}